import React from 'react';

import { getClientUrls, hasPricesEditPermission, UpgradeNotification } from '@paragon/login-tools';

import { useAppSelector } from './hooks';

export function CallToUpgrade() {
  const hasEditPermission = useAppSelector(hasPricesEditPermission);
  const urls = useAppSelector(getClientUrls);

  return (
    <UpgradeNotification
      active={!hasEditPermission}
      description="Upgrade to create or edit prices"
      trialDescription="Start your free trial to create or edit prices"
      onUpgradeClick={() => void window.open(`${urls.servicesUrl}account`, '_self')}
      sx={{ textWrap: 'nowrap', height: '40px' }}
    />
  );
}
